import React from 'react';
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip,} from 'chart.js';
import {Bar} from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
);

const StackedBarChart = (props) => {
	const {labels, datasets, showLegend = true} = props;

	const options = {
		plugins: {
			title: {
				display: false
			},
			legend: {
				display: true, // This will show the legend
				position: 'bottom', // This will move it to the bottom,
				labels: {
					boxWidth: showLegend ? 30 : 0,
					color: showLegend ? '' : 'transparent'
				}
			},
		},
		responsive: true,
		scales: {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
				title: {
					display: true,
					text: 'Record Count',
					font: {
						size: 14,
						weight: 'bold'
					}
				}
			},
		},
	};

	const colors = ["#126380", "#FF9E67", "#FFC267", "#67EDFF", "#40A0C1"];

	const data = {
		labels,
		datasets: datasets.map((ds, i) => ({
			label: ds.label,
			data: ds.values,
			backgroundColor: colors[i],
			maxBarThickness: 100,
			borderRadius: 10
		}))
	};

	return (
		<Bar options={options} data={data} width={300} height={230} />
	);
};

export default StackedBarChart;
